import { useEffect, useState } from "react";

export const useTypewriter = (texts: string[], speed = 20) => {
    const [displayText, setDisplayText] = useState('');
    const pauseSpeed = 1000;

    const typewriterStyle: React.CSSProperties = {
      overflow: "hidden",
      borderRight: ".15em solid orange",
      margin: "0 auto",
      letterSpacing: ".15em",
      animation: "blink-caret 1s step-end infinite",
      marginRight: displayText === "" ? "10px" : "0px"
    };
    
    useEffect(() => {
      let textIndex = 0;
      let charIndex = 0;

      function typeCharacter(prevText: string) {
        if (charIndex < texts[textIndex].length) {
          const newText = prevText + texts[textIndex].charAt(charIndex);
          setDisplayText(newText);
          setTimeout(() => typeCharacter(newText), speed);
        } else {
          setTimeout(() => deleteCharacter(prevText), pauseSpeed);
        }
        charIndex++;
      };

      function deleteCharacter(prevText: string) {
        if (charIndex > 0) {
          const newText = prevText.substring(0, prevText.length-1);
          setDisplayText(newText);
          setTimeout(() => deleteCharacter(newText), speed);
        } else {
          if (textIndex + 1 < texts.length) {
            textIndex++;
          } else {
            textIndex = 0;
          }
          setTimeout(() => typeCharacter(prevText), pauseSpeed);
        }
        charIndex--;
      };
    
      setTimeout(() => typeCharacter(""), pauseSpeed);
    
    }, []);
  
    return (<span style={typewriterStyle} >{displayText}</span>);
  };